module.exports = __webpack_public_path__ + "47a18e6a1944c403f17642f66c4922d3.svg";